import { observer } from "mobx-react-lite"
import { useMemo } from "react";
import { participantsStore } from "../../store/participantsStore";
import BlockUserModal from "../Panels/UserLIstPanel/BlockUserModal/BlockUserModal";
import KickOffModal from "../Panels/UserLIstPanel/KickOff/KickOffModal";

const ParticipantsPopup = observer(()=> {
    const {blockUserModal, kickOffModal, handleKickOff, handleBlockUser} = participantsStore;

    const onBlockUser = ()=> {
        handleBlockUser()
    }
    
    const onKickOff = (interval)=> {
        handleKickOff(interval)
    }

    const isActive = useMemo(()=> blockUserModal || kickOffModal)

    return (
        <div className={`participants_popups ${isActive ? 'active' : ''}`}>
            {
                blockUserModal && <BlockUserModal onBlock={onBlockUser}/>
            }
            {
                kickOffModal && <KickOffModal onKickOff={onKickOff}/>
            }
        </div>
    )
})

export default ParticipantsPopup